import { createApp } from 'vue'
import FButton from '~/js/components/button'

const CLASS_NAME = 'js-snippetsNotFound'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(CLASS_NAME)
  if (!elements.length) return

  Array.from(elements).forEach((element) => {
    createApp({
      name: 'SnippetsNotFound',
      components: {
        FButton,
      },
    }).mount(element)
  })
})
